import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/02Navigation/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/MainWrapper.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/home/runner/work/SOFAR/SOFAR/app/GoogleAnalytics.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-roboto\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/SOFAR/SOFAR/node_modules/react-hot-toast/dist/index.mjs");
